/**
 * Light deterrent for casual saving of the artwork: no image right-click menu and no dragging on
 * Impulse Theory artwork images. Links, buttons, keyboard and touch taps work as normal.
 * This is not theft-proof; anything on screen can still be captured.
 */
(() => {
  const ART = 'img.itc-art, .itc-lightbox__img';
  const isArt = (target) => target instanceof Element && target.matches(ART);
  document.addEventListener('contextmenu', (event) => { if (isArt(event.target)) event.preventDefault(); });
  document.addEventListener('dragstart', (event) => { if (isArt(event.target)) event.preventDefault(); });
})();
